import React, { useEffect, useState } from 'react';
import './coursesHoverCard.css'
import C2wcourseCardHoverDateinfo from './C2wCourseCountHoverinfo';
import C2wCourseCountHover from './courseCountHover';
import { useNavigate } from 'react-router';

function C2wCoursesHoverCard( { obj=null } ) {
  const navigate = useNavigate('')
  const rendredCoursesCountsCards = obj?.topicArray?.map(( objCount, idx) => {
    return <C2wCourseCountHover obj={objCount} />
  })
  
  const generateSlug = (name) =>
  name?.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  return (
    <div className='C2wCoursesHoverCard_ctn' onClick={() => {
        navigate(`/courses/${generateSlug(obj?.slug)}`);
    }}>
      <img className='C2wCoursesHoverCard_ctn_thumnnail_img' src={`/assets/images/courses/${obj?.thumbnailImage}`} alt='corse-img' />
        {windowWidth>620?<div className='C2wCoursesHoverCard_feesdiv'>
            {`₹ ${obj?.fees}`}
            <div className='C2wCoursesHoverCard_line'></div> 
            <div className='C2wCoursesHoverCard_feesDivGST'>{`+ ${obj?.gst}% GST`}</div>   
        </div>:null}

        {windowWidth>620?<div className='C2wCoursesHoverCard_hover_ctn'>
          <C2wcourseCardHoverDateinfo title={obj?.admissionType} validity={obj?.validityType} />
            <div className='C2wCourseCard_hover_Count_ctn'>
                {rendredCoursesCountsCards}
            </div>  
        </div>:null}
    </div>
  )
}

export default C2wCoursesHoverCard
